
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { WelcomeVideoModal } from "./WelcomeVideoModal";

interface RulesProps {
  onOpenChange?: (open: boolean) => void;
  isOpen?: boolean;
}

export function Rules({
  onOpenChange,
  isOpen
}: RulesProps) {
  const [open, setOpen] = useState(isOpen || false);
  const [showVideo, setShowVideo] = useState(false);
  
  // YouTube video ID for the welcome/tutorial video
  const youtubeVideoId = "lEZemROzYhA";
  
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    if (onOpenChange) onOpenChange(newOpen);
  };
  
  const handleWatchVideo = () => {
    setShowVideo(true);
  };
  
  const handleVideoClose = () => {
    setShowVideo(false);
  };
  
  return (
    <>
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogTrigger asChild>
          <Button variant="outline" className="w-full text-black border-gray-300 hover:bg-gray-100 hover:text-black text-lg font-medium rounded-lg px-5 py-4 h-auto">
            How to Play
          </Button>
        </DialogTrigger>
        
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-center">How to Play</DialogTitle>
          </DialogHeader>
          <ScrollArea className="h-[70vh] pr-4">
            <div className="space-y-6">
              <div className="text-center mb-6">
                <button 
                  onClick={handleWatchVideo}
                  className="text-blue-600 hover:text-blue-800 underline font-medium text-lg flex items-center justify-center mx-auto"
                >
                  Watch Video Tutorial
                </button>
              </div>
              
              <div className="space-y-4">
                <div className="pl-4 mb-4 text-center">
                  <h3 className="text-lg font-semibold">1. Choose Your Logic</h3>
                  <p className="text-gray-600">Each day, you'll see one Logic Card like Weight: Heavy to Light. Choose how you will apply this logic to the Word Cards.</p>
                </div>
                
                <div className="pl-4 mb-4 text-center">
                  <h3 className="text-lg font-semibold">2. Rank the Word Cards</h3>
                  <p className="text-gray-600">You'll rank the five Word Cards based on the logic card. Tap them in the order that fits the Logic. You can adjust until you're sure.</p>
                  <p className="text-gray-600">
                </p>
                </div>
                
                <div className="pl-4 mb-4 text-center">
                  <h3 className="text-lg font-semibold">3. Lock It In</h3>
                  <p className="text-gray-600">Once your ranking feels right, Lock In.</p>
                  <p className="text-gray-600">Time matters, so don't take all day.</p>
                </div>
                
                <div className="pl-4 mb-4 text-center">
                  <h3 className="text-lg font-semibold">4. Reveal the Results</h3>
                  <p className="text-gray-600">Instantly see how your ranking compares to the game logic.</p>
                  <p className="text-gray-600">Match 5 out of 5? That's perfect logic!</p>
                </div>
                
                <div className="pl-4 mb-4 text-center">
                  <h3 className="text-lg font-semibold">5. Come Back Tomorrow!</h3>
                  <p className="text-gray-600">One game. Once a day.
See how in sync your rank order was with the community!</p>
                </div>
              </div>
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
      
      {/* Welcome Video Modal */}
      <WelcomeVideoModal 
        videoId={youtubeVideoId} 
        open={showVideo} 
        onClose={handleVideoClose} 
      />
    </>
  );
}
